export default "__VITE_ASSET__16951527__"